<template>
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 20 21"
  >
    <path
      d="M10,10.5c.5,0,1-.2,1.4-.6.4-.4.6-.8.6-1.4s-.2-1-.6-1.4c-.4-.4-.8-.6-1.4-.6s-1,.2-1.4.6c-.4.4-.6.8-.6,1.4s.2,1,.6,1.4c.4.4.8.6,1.4.6ZM10,18.3c2.1-1.9,3.7-3.7,4.8-5.3,1.1-1.6,1.6-3.1,1.6-4.3,0-1.9-.6-3.4-1.8-4.7-1.2-1.2-2.8-1.9-4.6-1.9s-3.4.6-4.6,1.9c-1.2,1.2-1.8,2.8-1.8,4.7s.5,2.7,1.6,4.3c1.1,1.6,2.7,3.4,4.8,5.3ZM10,20.8c-2.8-2.3-4.9-4.5-6.3-6.5-1.4-2-2.1-3.9-2.1-5.6s.8-4.4,2.4-6C5.6,1,7.6.2,10,.2s4.4.8,6,2.4c1.6,1.6,2.4,3.6,2.4,6s-.7,3.6-2.1,5.6c-1.4,2-3.5,4.2-6.3,6.6Z"
    />
  </svg>
</template>
